module.exports = __webpack_public_path__ + "43f360b66617195675410e406f4ce231.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/around/cloud.png
// module id = 1158
// module chunks = 0